
export const UserUtils = {
  methods: {
    /** @param userRole {UserRoleDto} */
    getUserRoleName (userRole) {
      return this.$t('user.roles.' + userRole.toLowerCase());
    },
  }
};
